import { BrowserRouter, Route, Routes } from "react-router-dom"
import { Header } from "./components/Header/Header"
import { MainPage } from "./pages/MainPage/MainPage"
import { Footer } from "./components/Footer/Footer"
import { MoviePage } from "./pages/MoviePage/MoviePage"
import { NotFound } from "./pages/NotFound/NotFound"
import { ProfilePage } from "./pages/ProfilePage/ProfilePage"
import { GenresPage } from "./pages/GenresPage/GenresPage"
import { GenrePageOne } from "./pages/GenrePageOne/GenrePageOne"


function App() {

  return (
    <BrowserRouter>
    <Header/>
    <main className="main">
    <Routes>
    <Route path="*" element={<NotFound />} />
    <Route path="/" element={<MainPage />} />
    <Route path="/genres" element={<GenresPage/>} />
    <Route path="/genres/:genreName" element={<GenrePageOne/>} />
    <Route path="movie/:movieId" element={<MoviePage/>} />
    <Route path="/profile" element={<ProfilePage/>} />
    </Routes>
    </main>
    <Footer />
    </BrowserRouter>
    
  )
}

export default App
